import PropTypes from 'prop-types';

const FilterType = PropTypes.shape({
  task: PropTypes.arrayOf(PropTypes.string),
  phase: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    status: PropTypes.string,
  })),
  flag: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    suboption: PropTypes.string,
  })),
  surface_type: PropTypes.arrayOf(PropTypes.number),
});

export const PhaseFilterLocationType = PropTypes.shape({
  workroom: PropTypes.arrayOf(PropTypes.number),
  store: PropTypes.arrayOf(PropTypes.number),
  region: PropTypes.arrayOf(PropTypes.number),
  surface_type: PropTypes.arrayOf(PropTypes.number),
  product_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
});

export const CalendarFilterType = PropTypes.shape({
  workroom: PropTypes.arrayOf(PropTypes.number),
  assignee_type: PropTypes.arrayOf(PropTypes.string),
  surface_type: PropTypes.arrayOf(PropTypes.number),
  estimator: PropTypes.shape({
    zip_code: PropTypes.string,
    estimator_id: PropTypes.number,
  }),
}).isRequired;

export default FilterType;



// WEBPACK FOOTER //
// ./client/app/shared/types/filter.js